import NotificationsReducer from './NotificationsReducer';
export default NotificationsReducer;
